import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
/** 시스템정보 */
import COD_BASIC from '../../Scripts/SystemInfo/Code/COD_BASIC/COD_BASICF'; //기초관리 < 코드관리
import MEN_BASIC from '../../Scripts/SystemInfo/Menu/MEN_BASIC/MEN_BASICF'; //기초관리 < 메뉴관리
import AUT_BASIC from '../../Scripts/SystemInfo/Auth/AUT_BASIC/AUT_BASICF'; //기초관리 < 권한관리
import LAN_BASIC from '../../Scripts/SystemInfo/Language/LAN_BASIC/LAN_BASICF'; //기초관리 < 언어팩관리
import COU_BASIC from '../../Scripts/SystemInfo/CompanyMenu/COU_BASIC/COU_BASICF'; //기초관리 < 회사별 메뉴관리
import IND_BASIC from '../../Scripts/SystemInfo/IndustryMenu/IND_BASIC/IND_BASICF'; //기초관리 < 업종별 메뉴관리
import DAT_BASIC from '../../Scripts/SystemInfo/DataMigration/DAT_BASIC/DAT_BASICF'; //기초관리 < 데이터 이관

/** 대시보드 */
import MAI_BASIC from '../../Scripts/DashBoard/DashboardMain/MAI_BASIC/MAI_BASIC/MAI_BASICF'; //대시보드 < 대시보드 요약
import CUL_BASIC from '../../Scripts/DashBoard/CompanyUsageList/CUL_BASIC/CUL_BASICF'; //대시보드 < 회사별 상세 현황
import REV_BASIC from '../../Scripts/DashBoard/Revisions/REV_BASIC/REV_BASICF'; //대시보드 < 요구사항/리비전 보드(REV)

/** 기준정보관리 */
import COM_BASIC from '../../Scripts/BasicInfo/Company/COM_BASIC/COM_BASICF'; //회사정보관리
import PLA_BASIC from '../../Scripts/BasicInfo/Plant/PLA_BASIC/PLA_BASICF'; //사업장관리
import MEM_BASIC from '../../Scripts/BasicInfo/Member/MEM_BASIC/MEM_BASICF'; //인력관리
import DEP_BASIC from '../../Scripts/BasicInfo/Department/DEP_BASIC/DEP_BASICF'; //부서관리
import GON_BASIC from '../../Scripts/BasicInfo/Gongjong/GON_BASIC/GON_BASICF'; //공종관리

/** 공지/게시 */
import NOT_BASIC from '../../Scripts/NoticeBoard/Notice/NOT_BASIC/NOT_BASICF'; //공지사항 등록(리스트)
import NOT_BASIC_01 from '../../Scripts/NoticeBoard/Notice/NOT_BASIC_01/NOT_BASIC_01F'; //공지사항 등록(상세)
import NOT_BASIC_01_01 from '../../Scripts/NoticeBoard/Notice/NOT_BASIC_01_01/NOT_BASIC_01_01F'; //공지사항 등록(상세)
import NOT_BASIC_01_02 from '../../Scripts/NoticeBoard/Notice/NOT_BASIC_01_02/NOT_BASIC_01_02F'; //공지사항 등록(추가, 수정)
import NOT_BASIC_02 from '../../Scripts/NoticeBoard/Notice/NOT_BASIC_02/NOT_BASIC_02F'; //공지사항 등록(추가, 수정)
// import NOT_BASIC from '../../Scripts/Etc/Notice/NOT_BASIC/NOT_BASICF'; //공지사항 등록(리스트)
// import NOT_BASIC_01 from '../../Scripts/Etc/Notice/NOT_BASIC_01/NOT_BASIC_01F'; //공지사항 등록(상세)
// import NOT_BASIC_02 from '../../Scripts/Etc/Notice/NOT_BASIC_02/NOT_BASIC_02F'; //공지사항 등록(추가, 수정)
// import LAW_BASIC from '../../Scripts/Board/LawSummary/LAW_BASIC/LAW_BASICF'; //법령요지
// import SAS_BASIC from '../../Scripts/Board/SafetySigns/SAS_BASIC/SAS_BASICF'; //안전보건표지
// import SAR_BASIC from '../../Scripts/Board/SafetyRules/SAR_BASIC/SAR_BASICF'; //안전보건관리규정
// import PEN_BASIC from '../../Scripts/Board/PenaltyRules/PEN_BASIC/PEN_BASICF'; //벌칙규정

/** 기타 */
import SCH_BASIC from '../../Scripts/Etc/Schedule/SCH_BASIC/SCH_BASICF'; //스케줄관리
import AI_BASIC from '../../Scripts/Etc/Aicall/AI_BASIC/AI_BASICF'; //보이스 체크
import AIM_BASIC from '../../Scripts/Etc/AicallManager/AIM_BASIC/AIM_BASICF'; //보이스 체크관리
import AIS_BASIC from '../../Scripts/Etc/AicallStatus/AIS_BASIC/AIS_BASICF'; //보이스 체크현황
import ADM_BASIC from '../../Scripts/Etc/AiDocumentManager/ADM_BASIC/ADM_BASICF'; //AI문서관리

/** 안전보건관리체제 */
import POL_BASIC from '../../Scripts/SafetySystem/PolicyAndGoals/POL_BASIC/POL_BASICF'; //안전보건경영방침
import BUD_BASIC from '../../Scripts/SafetySystem/BudgetManagement/BUD_BASIC/BUD_BASICF'; //예산 편성 및 집행
import SAP_BASIC from '../../Scripts/SafetySystem/SafetyPersonnel/SAP_BASIC/SAP_BASICF'; //안전보건인력
import SUB_BASIC from '../../Scripts/SafetySystem/SubcontractorManagement/SUB_BASIC/SUB_BASICF'; //도급사업관리
import LEG_BASIC from '../../Scripts/SafetySystem/LegalCompliance/LEG_BASIC/LEG_BASICF'; //법규준수평가
import SER_BASIC from '../../Scripts/SafetySystem/SeriousAccidentAct/SER_BASIC/SER_BASICF'; //중대재해처벌법 이행관리
import SER_BASIC_01 from '../../Scripts/SafetySystem/SeriousAccidentAct/SER_BASIC_01/SER_BASIC_01F'; //중대재해처벌법 이행관리
import EMR_BASIC from '../../Scripts/SafetySystem/EmergencyManual/EMR_BASIC/EMR_BASICF'; //비상대응매뉴얼
import SAC_BASIC from '../../Scripts/SafetySystem/SafetyCommittee/SAC_BASIC/SAC_BASICF'; //산업안전보건위원회

/** 위험성평가 */
import RIS_BASIC from '../../Scripts/RiskAssessment/RiskEvaluation/RIS_BASIC/RIS_BASICF'; //위험성평가
import RIS_CUSTOM from '../../Scripts/RiskAssessment/RiskEvaluation/RIS_BASIC_CUSTOM/RIS_CUSTOMF'; //위험성평가

/** 안전작업 관리 */
import SAF_BASIC from '../../Scripts/SafeWork/SafeWorkProcedure/SAF_BASIC/SAF_BASICF'; //안전작업 관리
import SAM_BASIC from '../../Scripts/SafeWork/SafetyWorkManagement/SAM_BASIC/SAM_BASICF'; //안전작업 관리
import PPE_BASIC from '../../Scripts/SafeWork/PPEManagement/PPE_BASIC/PPE_BASICF'; //보호구관리
import HAZ_BASIC from '../../Scripts/SafeWork/HazardousMachines/HAZ_BASIC/HAZ_BASICF'; //유해위험기계기구

/** 교육 및 훈련 */
import TRA_BASIC from '../../Scripts/Training/TrainingPage/TRA_BASIC/TRA_BASICF'; //교육훈련
import TRA_CUSTOM from '../../Scripts/Training/MultiTrainingPage/TRA_CUSTOM/TRA_CUSTOMF'; //교육훈련
import SAT_BASIC from '../../Scripts/Training/SafetyHealthTraining/SAT_BASIC/SAT_BASICF'; //안전건강교육

/** 보건관리 */
import HAM_BASIC from '../../Scripts/HealthManagement/HazardousMaterials/HAM_BASIC/HAM_BASICF'; //유해 위험물질
import HEA_BASIC from '../../Scripts/HealthManagement/HealthCheckup/HEA_BASIC/HEA_BASICF'; //건강진단
import WOR_BASIC from '../../Scripts/HealthManagement/WorkEnvironment/WOR_BASIC/WOR_BASICF'; //작업환경측정
import MUS_BASIC from '../../Scripts/HealthManagement/MusculoskeletalSurvey/MUS_BASIC/MUS_BASICF'; //근골격계유해 위험요인 조사

/** 산업재해 */
import ACC_BASIC from '../../Scripts/Accidents/AccidentReport/ACC_BASIC/ACC_BASICF'; //산업재해조사표
import ACS_BASIC from '../../Scripts/Accidents/AccidentStatus/ACS_BASIC/ACS_BASICF'; //재해현황(산업재해현황, 아차사고현황, 통계)

import HEL_BASIC from '../../Scripts/HelpDesk/HEL_BASIC/HEL_BASICF';
import POP_BASIC from '../../Scripts/PopupManagement/POP_BASIC/POP_BASICF';

const ComponentMap = {
  COD_BASIC: COD_BASIC,
  MEN_BASIC: MEN_BASIC,
  AUT_BASIC: AUT_BASIC,
  LAN_BASIC: LAN_BASIC,
  COU_BASIC: COU_BASIC,
  IND_BASIC: IND_BASIC,
  DAT_BASIC: DAT_BASIC,
  MAI_BASIC: MAI_BASIC,
  CUL_BASIC: CUL_BASIC,
  REV_BASIC: REV_BASIC,
  COM_BASIC: COM_BASIC,
  PLA_BASIC: PLA_BASIC,
  MEM_BASIC: MEM_BASIC,
  DEP_BASIC: DEP_BASIC,
  GON_BASIC: GON_BASIC,
  NOT_BASIC: NOT_BASIC,
  NOT_BASIC_01: NOT_BASIC_01,
  NOT_BASIC_01_01: NOT_BASIC_01_01,
  NOT_BASIC_01_02: NOT_BASIC_01_02,
  NOT_BASIC_02: NOT_BASIC_02,
  SCH_BASIC: SCH_BASIC,
  AI_BASIC: AI_BASIC,
  AIM_BASIC: AIM_BASIC,
  AIS_BASIC: AIS_BASIC,
  POL_BASIC: POL_BASIC,
  BUD_BASIC: BUD_BASIC,
  SAP_BASIC: SAP_BASIC,
  SUB_BASIC: SUB_BASIC,
  LEG_BASIC: LEG_BASIC,
  SER_BASIC: SER_BASIC,
  SER_BASIC_01: SER_BASIC_01,
  EMR_BASIC: EMR_BASIC,
  SAC_BASIC: SAC_BASIC,
  RIS_BASIC: RIS_CUSTOM,
  SAF_BASIC: SAF_BASIC,
  SAM_BASIC: SAM_BASIC,
  PPE_BASIC: PPE_BASIC,
  HAZ_BASIC: HAZ_BASIC,
  TRA_BASIC: TRA_BASIC,
  TRA_CUSTOM: TRA_CUSTOM,
  HAM_BASIC: HAM_BASIC,
  HEA_BASIC: HEA_BASIC,
  WOR_BASIC: WOR_BASIC,
  //MUS_BASIC: MUS_BASIC,
  ACC_BASIC: ACC_BASIC,
  ACS_BASIC: ACS_BASIC,
  SAT_BASIC: SAT_BASIC,
  // LAW_BASIC: LAW_BASIC,
  // SAS_BASIC: SAS_BASIC,
  // SAR_BASIC: SAR_BASIC,
  // PEN_BASIC: PEN_BASIC,
  ADM_BASIC: ADM_BASIC,
  HEL_BASIC: HEL_BASIC,
  POP_BASIC: POP_BASIC,
};

const RouterCommon = () => {
  const { menuInfo } = useSelector((state) => state.BaseInfo);

  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();

  const row = menuInfo?.find((e) => e.menuId === currentPath);
  const proId = row?.proId;

  const SelectedComponent = proId ? ComponentMap[proId] : null;
  if (!SelectedComponent) {
    return null;
  }
  return <SelectedComponent />;
};

export default RouterCommon;
